// extracted by mini-css-extract-plugin
export default {"tableWrapper":"TableWrapper_tableWrapper__tf9LJ","table":"TableWrapper_table__dr3Wg","tableDisabled":"TableWrapper_tableDisabled__2fX3e"};